export default {
  rso: '退货单号',
  account: '客户',
  rsoSoldTo: '退货 Sold to',
  nikeSubmissionDate: '退货提交日期',
  latestOverdueConfiguration: '最新到货时间限制：',
  day: '天',
  submitQty: '提交数量',
  actualScanQty: '扫描数量',
  overdueQty: '超期数量',
  printBarcode: '打印标签',
  gledSo: '原发货订单号',
  rsoShipTo: '退货 Ship to',
  bigGroup: 'Big Group',
  productCode: '产品代码',
  sku: 'SKU',
  upc: 'UPC',
  epc: 'RFID EPC',
  validationResult: '检验结果',
  exceptionReason: '异常原因',
  cartonSequence: '箱序列号',
  giDate: 'GI日期',
  rsoCreationDate: 'RSO建单日期',
  scanDate: '扫描日期',
  epcVariance: 'EPC Variance',
  overdueConfiguration: '到货时间限制',
  device: '设备',
  operator: '操作人',
  skipRate: '跳过率',
  rejectRate: '拒收率',
  byRso: 'By RSO',
  byProductCode: 'By Product Code',
  byAccount: 'By Account',
  invalidRso: '无法找到该退货单号',
  overdue: '超 期',
  normal: '正 常',
  giOwnerGroup: '1028 Owner Group',
  rsoOwnerGroup: '退货 Owner Group',
  returnType: '退货类型',
  unableToValidate: '无法检验',
  rsoPlaceholder: '请扫描/输入退货单号',
  carton: '箱序列号 (选填)',
  cartonPlaceholder: '请输入箱号',
  epcPlaceholder: '请扫描',
  unitScanCount: '该箱扫描计数',
  nextCarton: '下一箱',
  nextUnit: '下一件',
  deviceError: '未能识别到设备编号，请联系Lst-GC.SCPT.NFC-RFID@Nike.com 升级APP。',
  downloadPdfError1: '未找到该退货单号',
  downloadPdfError2: '未知系统错误',
  readError: '离周围商品太近（<10cm）, 请调整后复扫。',
  dateMiss: 'OAE未设置最新到货时间限制',
  switchTo: '切换',
  qrCode: 'QR Code',
  noLabelProduct: '无标签商品',
  noHangTag: '实物无标签',
  noResponse: '经扫描无反应',
  invalidQRCodeFormat: '无效QR Code格式',
  noAssociatedEPC: '该QR code无关联EPC。',
  illegalQRCode: '非法QR Code。',
  tryAgain: '请再试一次。',
  confirm: '确认',
  cancel: '取消'
}
